import React from 'react';
import { translate, Labeled } from 'react-admin';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import AmountField from './AmountField';

/**
 * Takes a hash with balances and displays every balance as a separate AmountField.
 */
const AmountHashField = translate(({ label, source, record = {}, translate, ...props }) => {
	// Render nothing if record is not yet loaded or source field is not an object hash
	const hash = get(record, source);
	if (typeof hash !== 'object') {
		return null;
	}
	// Create a list of keys to iterate on, while making sure 'balance' always comes first
	const keys = Object.keys(hash)
		.reduce((accumulator, item) => {
			if (item === 'balance') {
				return [item, ...accumulator];
			} else {
				return [...accumulator, item];
			}
		}, []);
	return (
		keys.map(key =>
			<div
				key={`${source}.${key}`}
				className={`ra-field ra-field-${source}-${key}`}
			>
				<Labeled
					record={record}
					resource={props.resource}
					basePath={props.basePath}
					label={translate(`resources.${props.resource}.fields.${source}.${key}`)}
					source={`${source}.${key}`}
				>
					<AmountField source={`${source}.${key}`} record={record} {...props} />
				</Labeled>
			</div>
		)
	);
});

AmountHashField.propTypes = {
	label: PropTypes.string,
	record: PropTypes.object,
	source: PropTypes.string.isRequired
};

AmountHashField.defaultProps = {
	addLabel: false
};

export default AmountHashField;
